export default __webpack_public_path__ + "static/media/ic-check-off.4ad3767a.svg";